const getters = {
  //cache
  notifyToken: state => state.cache.notifyToken,
  channels: state => state.cache.channels,
  token: state => state.cache.token,
  refreshToken: state => state.cache.refreshToken,
  refreshTokenID: state => state.cache.refreshTokenID,
  tokenExpirationTime: state => state.cache.tokenExpirationTime,

  // 新增一個返回整個 cache 的 getter
  cache: state => ({ ...state.cache })
};
export default getters;
